
import CalcOfIpoteka from '~/components/calc-block/CalcOfIpoteka.vue';

export default {
  name: 'CalculatorIpoteka',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  components: {
    CalcOfIpoteka,
  },
  data() {
    return {
      programs: null,
    }
  },
  computed: {
    productPrice: function () {
      if (!this.product) {
        return;
      }
      return this.product.price;
    }
  },
  methods: {
    async getBanks() {
      const ipotekaPrograms = await this.$api.agent.transport.get('/banks/get-minimum').then((res) => res.data).catch(() => null);
      if (!ipotekaPrograms) {
        return;
      }
      this.programs = ipotekaPrograms
    },
  },
  mounted: async function () {
    await this.getBanks();
  }
}

